import React, { useState } from "react";
import { CommandBarButton, Aside } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../core/security/SprintAccessRight";
import { CreateBucketArchiveForm } from "./CreateBucketArchiveForm";

export const AddBucketArchiveButton: React.VFC = () => {
    const [isAsideOpen, setIsAsideOpen] = useState<boolean>(false);

    const openAside = () => {
        setIsAsideOpen(true);
    };

    const closeAside = () => {
        setIsAsideOpen(false);
    };

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.CiAdmin]}>
            <CommandBarButton onClick={openAside} text="Add" icon="Add" />
            <Aside
                type="form"
                headerText="Add Bucket Archive"
                isOpen={isAsideOpen}
                onDismiss={closeAside}
                isLightDismiss={true}
            >
                <CreateBucketArchiveForm onSubmit={closeAside} onCancel={closeAside} />
            </Aside>
        </AuthorizationWrapper>
    );
};
